import ImageModal from "./ImageModal.jsx";

export default ImageModal;